import app from 'firebase'
import 'firebase/auth'
import 'firebase/firestore'

var firebaseConfig = {
	apiKey: 'AIzaSyAt1hXKwitr_y6Bva1JgZ7QvdTzvkRk72w',
	authDomain: 'bunny-4de25.firebaseapp.com',
	databaseURL: 'https://bunny-4de25.firebaseio.com',
	projectId: 'bunny-4de25',
	storageBucket: 'bunny-4de25.appspot.com',
	messagingSenderId: '407598515177',
	appId: '1:407598515177:web:c56a96bab8955e39520178',
	measurementId: 'G-GCXB71V44V'
}

class Firebase {
	constructor() {
		app.initializeApp(firebaseConfig)
		this.auth = app.auth()
		this.db = app.firestore()
		this.googleProvider = new app.auth.GoogleAuthProvider()
		this.fieldValue = app.firestore.FieldValue
	}

	// *** Auth API ***

	doCreateUserWithEmailAndPassword = (email, password) =>
		this.auth.createUserWithEmailAndPassword(email, password)

	doSignInWithEmailAndPassword = (email, password) =>
		this.auth.signInWithEmailAndPassword(email, password)

	doSendEmailVerification = () =>
		this.auth.currentUser.sendEmailVerification({
			url: 'http://localhost:3000'
		})

	doSignInWithGoogle = () => this.auth.signInWithPopup(this.googleProvider)

	doSignOut = () => {
		console.log('sign out')
		this.auth.signOut()
	}

	doPasswordReset = email => this.auth.sendPasswordResetEmail(email)

	doPasswordUpdate = password => this.auth.currentUser.updatePassword(password)

	// *** Merge Auth and DB User API *** //

	onAuthUserListener = (next, fallback) => {
		return this.auth.onAuthStateChanged(authUser => {
			if (authUser) {
				this.user(authUser.uid)
					.get()
					.then(snapshot => {
						const dbUser = snapshot.data()

						// default empty roles
						if (dbUser && !dbUser.roles) {
							dbUser.roles = {}
						}

						// merge auth and db user
						authUser = {
							uid: authUser.uid,
							email: authUser.email,
							emailVerified: authUser.emailVerified,
							providerData: authUser.providerData,
							...dbUser
						}

						next(authUser)
					})
			} else {
				fallback()
			}
		})
	}

	user = id => (id ? this.db.doc(`users/${id}`) : this.db.collection(`users`))

	chapters = id =>
		id
			? this.db.doc(`pages/${id}`)
			: this.db.collection(`pages`).where('category', '==', 'chapters')

	wargear = id =>
		id
			? this.db.doc(`pages/${id}`)
			: this.db.collection('pages').where('category', '==', 'wargear')

	characters = id =>
		id
			? this.db.doc(`pages/${id}`)
			: this.db.collection('pages').where('category', '==', 'characters')

	page = id => (id ? this.db.doc(`pages/${id}`) : this.db.collection('pages'))

	category = (category, page) => {
      console.log("firebase", category, page)
		return page
			? this.db.doc(`pages/${page}`)
         : this.db.collection('pages').where('category', '==', category)
   }
}

export default Firebase
